module.exports = __webpack_public_path__ + "static/media/drc_itdel_logo.a0679e98.png";